import { Injectable } from '@angular/core';
import moment from 'moment';
import { of } from 'rxjs';
import { DashboardFilterModel, FilterModel } from 'src/app/shared/models/common-model';
import { CommonService } from 'src/app/shared/services/common.service';
@Injectable({
  providedIn: 'root'
})
export class ConsultFormService {
  getAllURL = 'ConsultForm/all-consult-forms';
  getByIdURL = "ConsultForm/consult-form-by-id";
  createURL = "ConsultForm/create-consult-form";
  updateURL = "ConsultForm/consult-form-update";
  getAllByOrgIdURL = "ConsultForm/all-consult-forms-by-orgId";
  getAllByDocIdURL = "ConsultForm/all-consult-forms-by-doctorId";
  getAllConsultsStatusCountsURL = "ConsultForm/all-consult-forms-status-count";
  getProgramByIdURL = "Hospital/hospital-program-by-id";


  pauseConsultFormURL = "ConsultForm/pause-consult-form";
  reassignConsultFormURL = "ConsultForm/reassign-consult-form";
  followupConsultFormURL = "ConsultForm/followup-consult-form";
  updateConsultFormStatusURL = "ConsultForm/consult-form-status-update";
  getConsultFormTimeLines = "ConsultForm/consult-form-timeline";

  getConsultForListById = "ConsultForm/consult-for-list-byId";

  createConsultChatURL = "ConsultForm/create-consult-chat";

  getAllNotificationByDocId = "Notification/get-doctor-notifications";
  markReadNotificationByDocId = "Notification/mark-all-notification-read";
  sendShiftAlertFollowup = "ConsultForm/followup-shift-escalation";
  getByIdFollowup = "ConsultForm/followup-getconsult";
  getDashboardDetail = 'Dashboard/dashboard-detail';
  constructor(private commonService: CommonService) { }
  getById(id: number) {
    return this.commonService.getById(this.getByIdURL + "?Id=" + id, {});
  }

  getByCIdForFollowup(id: string)   {
    return this.commonService.getById(this.getByIdFollowup + "?Id=" + id, {});
  }

  getByIdSkipLoader(id: number) {
    return this.commonService.getByIdSkipLoader(this.getByIdURL + "?Id=" + id, {});
  }

  getProgramById(id: number) {
    return this.commonService.getById(this.getProgramByIdURL + "?Id=" + id, {});
  }
  save(userModel: any) {
    var stillUtc = moment.utc(moment()).toDate();
    var local = moment(stillUtc).local();
    var curentTime = local.format("MM/DD/YYYY hh:mm A");
    userModel.localTime = curentTime;
    return this.commonService.post(this.createURL, userModel);
  }
  saveMessage(userModel: any) {
    return this.commonService.postFormData(this.createConsultChatURL, userModel);
  }

  update(userModel: any) {
    return this.commonService.put(this.updateURL, userModel);
  }

  pauseConsultForm(userModel: any) {
    return this.commonService.put(this.pauseConsultFormURL, userModel);
  }

  updateConsultFormStatus(userModel: any) {
    return this.commonService.put(this.updateConsultFormStatusURL, userModel);
  }

  reassignConsultForm(userModel: any) {
    return this.commonService.put(this.reassignConsultFormURL, userModel);
  }

  followupConsultForm(userModel: any) {
    return this.commonService.put(this.followupConsultFormURL, userModel);
  }

  getAll(filterModal: FilterModel) {
    return this.commonService.getAll(this.getAllURL, filterModal.currentPage, filterModal.pageSize,
      filterModal.searchText, filterModal.sortOrder, filterModal.orderBy, filterModal.status, filterModal.statusType, filterModal.hospitalId, filterModal.statusIds, filterModal.doctorIds, filterModal.dateFrom, filterModal.dateTo, filterModal.isActiveShift, filterModal.hospitalUserId, null, null, filterModal.isDoctorLogin);
  }

  getAllSkipLoader(filterModal: FilterModel) {
    return this.commonService.getAllSkipLoader(this.getAllURL, filterModal.currentPage, filterModal.pageSize,
      filterModal.searchText, filterModal.sortOrder, filterModal.orderBy, filterModal.status, filterModal.statusType, filterModal.hospitalId, filterModal.statusIds, filterModal.doctorIds, filterModal.dateFrom, filterModal.dateTo, filterModal.isActiveShift, filterModal.hospitalUserId, null, null, filterModal.isDoctorLogin);
  }
  getConsultForListByIdSkipLoader(id: number, isDoctorLogin: boolean) {
    return this.commonService.getByIdSkipLoader(this.getConsultForListById + "?consultFormId=" + id + "&isDoctorLogin=" + isDoctorLogin, {});
  }

  getAllByOrgId() {
    return this.commonService.getAllData(this.getAllByOrgIdURL);
  }
  getAllByDocId() {
    return this.commonService.getAllData(this.getAllByDocIdURL);
  }
  getAllStatusCounts() {
    return this.commonService.getAllData(this.getAllConsultsStatusCountsURL);
  }

  getTimeLines(id: number) {
    return this.commonService.getById(this.getConsultFormTimeLines + "?consultFormId=" + id + "&loginUserId=0", {});
  }

  getTimeLinesSkipLoader(id: number, loginUserId: number) {
    return this.commonService.getByIdSkipLoader(this.getConsultFormTimeLines + "?consultFormId=" + id + "&loginUserId=" + loginUserId, {});
  }

  getAllNotificationDocId(id: number) {
    return this.commonService.getAllDataSkipLoader(this.getAllNotificationByDocId + "?doctorId=" + id);
  }

  getNotificationDoc(id: number){
    return this.commonService.getAllDataSkipLoader(`Notification/get-doctor-pg-notifications?doctorId=${id}&currentpage=1&limit=20`);
  }

  markAllNotificationRead(userIdModel: any) {
    return this.commonService.put(this.markReadNotificationByDocId, userIdModel);
  }

  //checkUserAutorization(id: number) {
  //  return this.commonService.getAllDataSkipLoader(`Account/check-user-authorization?userId=${id}`);
  //}

  sendShiftAlertForFollowup(followupAlertModel: any) {
    return this.commonService.post(this.sendShiftAlertFollowup, followupAlertModel);
  }

  getDashboardData(filterModal: DashboardFilterModel) {
    return this.commonService.getDashboardData(this.getDashboardDetail, moment(filterModal.dateFrom).format("MM/DD/YYYY"), moment(filterModal.dateTo).format("MM/DD/YYYY"), filterModal.hospitalId, filterModal.hospitalProgramIds, filterModal.dashboardBy);
  }

  createConsultForm(requestBody: any) {
    return this.commonService.post(`ConsultForm/create-consult-form`, requestBody);
  }

  sendNotificationSMS(param: {phoneNumber: string|null, message: string}) {
    if(param.phoneNumber)
      return this.commonService.postWithParams(`Notification/send-sms`, {}, param);
    return of(null);
  }



  addDoctorToConsultChat(requestBody: {consultFormId: number, doctorId: number}) {
    return this.commonService.post(`ConsultForm/add-doctor-to-consult-chat`, requestBody);
  }


  removeDoctorToConsultChat(requestBody: {consultFormId: number, doctorId: number}) {
    return this.commonService.post(`ConsultForm/remove-doctor-from-consult-chat`, requestBody);
  }

  muteConsultForm(consultFormId: number) {
    return this.commonService.put(`ConsultForm/mute-consult-for-doctor?consultFormId=${consultFormId}`, {});
  }

}
